export function HomeScreen() {
    return (
        <>

        </>
    );
}

export default HomeScreen